module.exports = __webpack_public_path__ + "static/media/app-store-qr.aa9a9151.svg";